import src from "IMAGE";
export default { src, width: 242, height: 220, blurDataURL: null, blurWidth: 0, blurHeight: 0 }
